// TODO: tab trap maken

import Vimeo from '@vimeo/player';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';

export default class VideoModal {
	constructor() {
		// DOM elements
		this.modal = document.querySelector('[data-video-modal]');
		if(!this.modal){
			return;
		}
		this.closeButton = this.modal.querySelector('[data-video-modal-close]');
		this.videoWrapper = this.modal.querySelector('[data-video-modal-wrapper]');
		this.buttons = document.querySelectorAll('[data-fullscreen-video]');
		this.loader = this.modal.querySelector('.lds-ellipsis');

		this.buttons.forEach((button) => {
			button.addEventListener('click', this.createPlayer.bind(this));
		});

		this.closeButton.addEventListener('click', (e) => {
			this.closeModal();
		});
	}

	showLoader() {
		this.loader.classList.add('is-active');
	}

	hideLoader() {
		this.loader.classList.remove('is-active');
	}

	createPlayer(e) {
		const button = e.currentTarget;

		this.showLoader();

		const video = document.createElement('div');

		video.classList.add('c-video-modal__video');
		this.videoWrapper.appendChild(video);

		this.player = new Vimeo(video, {
			id: button.dataset.fullscreenVideo,
			autoplay: true,
		});

		this.player.ready().then(() => {
			this.hideLoader();
		});

		this.openModal();
	}

	openModal() {
		this.modal.classList.add('is-active');
		disablePageScroll();
	}

	closeModal() {
		this.modal.classList.remove('is-active');

		if (this.player) {
			this.player.destroy();
			this.videoWrapper.querySelector('.c-video-modal__video').remove();
		}

		enablePageScroll();
	}
}
